import * as React from 'react'

export type Country = 'en' | 'pt' | 'fr'

// Reference: https://mdbootstrap.com/docs/standard/content-styles/flags/
const flagsOffset = (flag: Country): string => {
  switch (flag) {
    case 'pt': return '-72px -702px'
    case 'en': return '-36px -26px'
    case 'fr': return '-36px -104px'
  }
}

export const Flag: React.FC<{flag: Country}> = ({flag}) => {
  return (<i style={{
    display: 'inline-block',
    width: '16px',
    height: '11px',
    background: `url(flags.png) no-repeat ${flagsOffset(flag)}`,
  }}/>)
} 
